<template>
  <div class="guideLine">
    <div class="guideTitle">
      {{ termsFromApi ? '' : '隱私權政策' }}
      <span class="close" @click="backTo">關閉</span>
    </div>
    <div v-if="termsFromApi" v-html="termsFromApi" class="guideContent"></div>
    <div v-else class="guideContent">
      <div>◎拍享券服務個人資料蒐集告知及隱私權保護政策</div>
      <div>
        <br />
        親愛的朋友，感謝您進入拍享券（以下簡稱本服務），本服務一向將使用者個人資料及隱私權的尊重及保障，視為本服務經營的基本政策。為了幫助您瞭解我們是如何蒐集、處理及利用您在本服務所提供的個人資料，請您詳細閱讀本服務個人資料蒐集告知及隱私權保護政策。這份政策將告訴您，我們在本服務內所蒐集、處理的資料內容及利用方式，以及我們對使用者隱私權保護政策採行的措施，這份政策亦構成康太數位使用規範同意書的一部分。
      </div>
      <br />
      <div>一、依個人資料保護法第8條規定之告知事項如下：</div>
      <div>
        <br />
        1、個人資料蒐集之主體：康太數位整合股份有限公司（即本服務提供商）所蒐集，並由前述主體處理與利用。
        <br />
      </div>
      <div>
        <br />
        2、個人資料蒐集之目的：
        <br />
        040 行銷（包含金控共同行銷業務）。
        <br />
        067 信用卡、現金卡、轉帳卡或電子票證業務。
        <br />
        069 契約、類似契約或其他法律關係事務。
        <br />
        077 訂位、住宿登記與購票業務。
        <br />
        090 消費者、客戶管理與服務。
        <br />
        098 商業與技術資訊。
        <br />
        127 募款（包含公益勸募）。
        <br />
        129 會計與相關服務。
        <br />
        135 資（通）訊服務。
        <br />
        136 資（通）訊與資料庫管理。
        <br />
        137 資通安全與管理。
        <br />
        148 網路購物及其他電子商務服務。
        <br />
        157 調查、統計與研究分析。
        <br />
        除上述項目外，其他符合本服務營業登記項目或章程所定得合法經營之業務目的。
        <br />
      </div>
      <div>
        <br />
        3、蒐集的個人資料類別：
        <br />
        C001
        辨識個人者。如：姓名、地址、室內電話號碼、行動電話、即時通訊申請之帳號、網路平臺申請之帳號、通訊及戶籍地址、電子郵遞地址、提供網路身分認證或申辦查詢服務之紀錄及其他任何可辨識資料本人者等。
        <br />
        C002
        辨識財務者。如：金融機構帳戶之號碼與姓名、信用卡或簽帳卡之號碼、個人之其他號碼或帳戶等。
        <br />
        C003 政府資料中之辨識者。如：身分證統一編號、護照號碼等。
        <br />
        C011 個人描述。如：年齡、性別、出生年月日、出生地、國籍、聲音等。
        <br />
        C012 身體描述。如：身高、體重、血型等。
        <br />
        C035 休閒活動及興趣。如：嗜好、運動及其他興趣等。
        <br />
        C036 生活格調。如：使用消費品之種類及服務之細節、個人之消費模式等。
        <br />
        C093 財務交易。如：收付金額、支付方式、往來紀錄等。
        <br />
        C102 約定或契約。如：關於交易、商業、法律或其他契約、代理等。
        <br />
        除上述類別外，其他詳如本服務資料欄位或相關申請書、同意書或契約文件
        <br />
      </div>
      <div>
        <br />
        4、個人資料利用的期間、地區、對象及方式：
        <br />
        （1）、期間：自您使用為本服務之日起，至您或本服務終止契約／申請結清帳戶之日止；個人資料蒐集目的消失或本服務執行業務所須保存之期間。（以上述各期間較長者為準，但法令另有規定者，依其規定。）
        <br />
        （2）、地區：中華民國地區及本服務相關業務合作夥伴（含供貨商、物流商及其他履行輔助人或代理人）所在地區與提供服務地區。
        <br />
        （3）、對象：康太數位整合股份有限公司及本服務為提供使用者服務所必要之相關業務合作夥伴或履行輔助人、政府機關等。
        <br />
        （4）、方式：以電子、書面、電話、電信、網際網路及其他方式於蒐集之特定目的範圍內處理並利用個人資料。
        <br />
      </div>
      <div>
        <br />
        5、您可向本服務主張之權利種類及行使方式：
        <br />
        （1）、權利種類：
        <br />
        a、查詢或請求閱覽。
        <br />
        b、製給複製本。
        <br />
        c、補充或更正。
        <br />
        d、請求停止蒐集、處理或利用。
        <br />
        e、申請結清帳戶。
        <br />
        （2）、行使方式：
        <br />
        a、來電康太數位客服中心（02）7729-9040 提出申請。
        <br />
        b、得以由客服中心提供的網址提出申請。
        <br />
        （3）、本服務將依據您提出可資確認的身分證明文件申請及所需的事實釋明，履行上述義務，但法令另有規定，或本服務依法執行業務所須保存或利用您的個人資料者，不在此限。若您委託他人代為申請者，請另外提出可資確認的身分及授權證明，以備查核。若您申請查詢或請求閱覽個人資料或製給複製本，本服務得酌收相當費用。收費將依本服務所規定的標準辦理。若本服務未能於法定期間內處理您的申請，將會將原因以書面方式告知使您知悉。若您委託他人代為登入者，您將負完全的責任。
        <br />
      </div>
      <div>
        <br />
        6、您有自由選擇提供個人資料之權利，但若不提供時，您將不能使用本服務之全部或部分的個人化服務或加值服務，亦無從使本服務履行對您的契約相關權利或義務。
      </div>
      <br />
      <div>二、本服務隱私權保護政策如下：</div>
      <div>
        1、您於本服務所登錄或留存的個人資料，係由本服務蒐集、處理、利用，在未獲得您的同意以前，絕不對本服務或相關業務合作夥伴以外的第三人任意揭露您的姓名、電話、地址、電子郵件及其他依法受保護的個人資料。
        <br />
      </div>
      <div>
        2、為提供本服務行銷、市場分析、統計或研究、或為提供個人化服務或加值服務之目的，您同意本公司及本公司相關業務夥伴，得記錄、保存及利用您在本服務所留存或產生的資料及記錄，並得將您的資料及記錄提供予相關業務夥伴，同時在不揭露各該資料的情形下，得公開或使用統計資料。
        <br />
      </div>
      <div>
        3、本服務會記錄使用者上站的IP位址、及在頁面內瀏覽活動等資料，但這些資料僅供本服務及相關業務夥伴內部作頁面流量和網路行為調查的總量分析，利於提昇本服務的服務品質，同時在不揭露各該資料的情形下，公開或使用統計資料。
        <br />
      </div>
      <div>
        4、除符合下列情形之一，本服務不得將個人資料進行前述特定目的外之利用：
        <br />
        （1）、法律明文規定；
        <br />
        （2）、為增進公共利益；
        <br />
        （3）、為免除當事人之生命、身體、自由或財產上之危險；
        <br />
        （4）、為防止他人權益之重大危害；
        <br />
        （5）、經當事人書面同意。
        <br />
      </div>
      <div>
        5、為了便利使用者的網頁瀏覽及操作，本服務可能使用cookie技術或其他類似技術，以提供更適合使用者個人需要的服務。cookie是網站伺服器用來和使用者瀏覽器進行溝通的一種技術，它可能在使用者的電腦中儲存某些資訊。使用者可以經由瀏覽器的設定，取消或限制此項功能。
        <br />
      </div>
      <div>
        6、為了保障您的隱私與安全，您的個人資料由本服務現行通行標準的SSL保全系統，保障資料傳送的安全。
        <br />
      </div>
      <div>
        7、本服務相關頁面可能包含其他網站或網頁的連結。對於此等不屬於本服務的頁面，其內容或隱私權政策，均與本服務無關。
        <br />
      </div>
      <div>
        8、本服務於個人資料於蒐集、處理及利用時，皆尊重當事人之權益，依誠實及信用方法為之，且在被規範之特定目的範圍內，最小化處理及利用個人資料。
        <br />
      </div>
      <div>
        9、使用者若對於本政策，或與個人資料有關的其他事項，可與康太數位客服中心聯絡，我們將會提供最完整的說明。
        <br />
      </div>
      <div>
        10、本服務將會視需要或法令異動，隨時修改本政策，以落實保障您個人資料及隱私權的立意。當我們完成本政策條款修改時，將立即刊登於本服務上，請您隨時注意前往點選詳閱，若屬於重大的變更，我們會另外在本服務上醒目標示或是以個別電子信件提醒您注意點選閱讀。
        <br />
      </div>
      <div>
        <br />
        願您有個愉快、豐富的購物之旅！
        <br />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GuideLine',
  components: {},
  data: function() {
    return {
      termsFromApi: '',
    }
  },
  methods: {
    backTo() {
      this.$router.back()
    },
  },
  created() {
    this.termsFromApi = JSON.parse(
      window.localStorage.getItem('initial_config')
    ).terms.privacyPolicy
  },
}
</script>

<style lang="scss" scoped>
.guideTitle {
  width: 100%;
  margin: 30px auto 10px;
  text-align: center;
  font-size: 22px;
  padding: 0 16px;
  position: relative;
  .close {
    position: absolute;
    top: 7px;
    right: 16px;
    font-size: 16px;
    text-decoration: underline;
    color: #222;
  }
}
.guideContent {
  padding: 0px 16px 20px;
}
</style>
